import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const ModuleAdminContext = createContext(null);

// declare provider component
const ModuleAdminProvider = ({ children }) => {
  const [module, setModule] = useState(null);
  const [initialGroupTypePermissions, setInitialGroupTypePermissions] = useState(null);
  const [currentGroupTypePermissions, setCurrentGroupTypePermissions] = useState(null);
  const [groupTypePermissionsLoading, setGroupTypePermissionsLoading] = useState(true);
  const [groupTypePermissionsError, setGroupTypePermissionsError] = useState(false);
  const [initialGroupPermissions, setInitialGroupPermissions] = useState(null);
  const [currentGroupPermissions, setCurrentGroupPermissions] = useState(null);
  const [groupPermissionsLoading, setGroupPermissionsLoading] = useState(true);
  const [groupPermissionsError, setGroupPermissionsError] = useState(false);
  const [updateStatus, setUpdateStatus] = useState('initial');

  const setTheModule = (module) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheModule'); }
    let newModule = module ? { ...module } : null;
    setModule(newModule);
  }

  const setTheInitialGroupTypePermissions = (groupTypePermissions) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheInitialGroupTypePermissions'); }
    let newInitialGroupTypePermissions = groupTypePermissions ? [...groupTypePermissions] : null;
    setInitialGroupTypePermissions(newInitialGroupTypePermissions);
  }

  const setTheCurrentGroupTypePermissions = (groupTypePermissions) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheCurrentGroupTypePermissions'); }
    let newCurrentGroupTypePermissions = groupTypePermissions ? [...groupTypePermissions] : null;
    setCurrentGroupTypePermissions(newCurrentGroupTypePermissions);
  }

  const setTheGroupTypePermissionsLoading = (groupTypePermissionsLoading) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheGroupTypePermissionsLoading'); }
    setGroupTypePermissionsLoading(groupTypePermissionsLoading);
  }

  const setTheGroupTypePermissionsError = (groupTypePermissionsError) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheGroupTypePermissionsError'); }
    setGroupTypePermissionsError(groupTypePermissionsError);
  }

  const setTheInitialGroupPermissions = (groupPermissions) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheInitialGroupPermissions'); }
    let newInitialGroupPermissions = groupPermissions ? [...groupPermissions] : null;
    setInitialGroupPermissions(newInitialGroupPermissions);
  }

  const setTheCurrentGroupPermissions = (groupPermissions) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheCurrentGroupPermissions'); }
    let newCurrentGroupPermissions = groupPermissions ? [...groupPermissions] : null;
    setCurrentGroupPermissions(newCurrentGroupPermissions);
  }

  const setTheGroupPermissionsLoading = (groupPermissionsLoading) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheGroupPermissionsLoading'); }
    setGroupPermissionsLoading(groupPermissionsLoading);
  }

  const setTheGroupPermissionsError = (groupPermissionsError) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheGroupPermissionsError'); }
    setGroupPermissionsError(groupPermissionsError);
  }

  const setTheUpdateStatus = (updateStatus) => {
    if (logComponent('ModuleAdminContext')) { console.debug('ModuleAdminContext setTheUpdateStatus'); }
    setUpdateStatus(updateStatus);
  }



  const moduleAdminState = useMemo(() => ({
    module,
    initialGroupTypePermissions,
    currentGroupTypePermissions,
    groupTypePermissionsLoading,
    groupTypePermissionsError,
    initialGroupPermissions,
    currentGroupPermissions,
    groupPermissionsLoading,
    groupPermissionsError,
    updateStatus,
    setModule: setTheModule,
    setInitialGroupTypePermissions: setTheInitialGroupTypePermissions,
    setCurrentGroupTypePermissions: setTheCurrentGroupTypePermissions,
    setGroupTypePermissionsLoading: setTheGroupTypePermissionsLoading,
    setGroupTypePermissionsError: setTheGroupTypePermissionsError,
    setInitialGroupPermissions: setTheInitialGroupPermissions,
    setCurrentGroupPermissions: setTheCurrentGroupPermissions,
    setGroupPermissionsLoading: setTheGroupPermissionsLoading,
    setGroupPermissionsError: setTheGroupPermissionsError,
    setUpdateStatus: setTheUpdateStatus,

  }), [
    module,
    initialGroupTypePermissions,
    currentGroupTypePermissions,
    groupTypePermissionsLoading,
    groupTypePermissionsError,
    initialGroupPermissions,
    currentGroupPermissions,
    groupPermissionsLoading,
    groupPermissionsError,
    updateStatus
  ]);

  return (
    <ModuleAdminContext.Provider value={moduleAdminState}>
      {children}
    </ModuleAdminContext.Provider>
  );
}

// export provider and context
export { ModuleAdminContext, ModuleAdminProvider };